<template>
<div>
    <div class="row d-flex align-items-center justify-content-start">
        <div class="col-10">
            <Button @click="$router.push('/group')" size="small" type="outline" color="grey">
                <ArrowDropdown :rotate="90" /> Voltar
            </Button>
        </div>
        <div class="col-10 my-4">
            <h3 class="c-ndarkthree">
                <span class="bold">{{ $store.state.group.group.name }}</span> | Dados do grupo
            </h3>
        </div>
        <div class="col-10">
            <el-form :model="group" ref="group">
                <div class="row">
                    <div class="col-6">
                        <el-form-item prop="name">
                            <label>Nome do grupo</label>
                            <el-input :class="getPrimaryColor" v-model="group.name" placeholder="Nome do grupo"/>
                        </el-form-item>
                    </div>
                </div>
                <div class="row">
                    <div class="col-4">
                        <el-form-item prop="city">
                            <label>Cidade</label>
                            <el-input :class="getPrimaryColor" v-model="group.city" placeholder="Cidade"/>
                        </el-form-item>
                    </div>
                    <div class="col-2">
                        <el-form-item prop="state">
                            <label>Estado</label>
                            <el-input :class="getPrimaryColor" v-model="group.state" placeholder="UF"/>
                        </el-form-item>
                    </div>
                </div>
                <div class="row">
                    <div class="col-6">
                        <el-form-item prop="site">
                            <label>Website</label>
                            <el-input :class="getPrimaryColor" v-model="group.site" placeholder="Website"/>
                        </el-form-item>
                    </div>
                </div>
                <div class="row">
                    <div class="col-6">
                        <el-form-item prop="partnerId" v-if="!USER_TYPE_MIXIN.isBackOffice">
                            <label for="">Parceiro vinculado</label>
                            <el-select v-model="group.partnerId" placeholder="Selecione">
                                <el-option
                                    v-for="partner in partners"
                                    :key="partner.name"
                                    :label="partner.name | formatName"
                                    :value="partner.id"
                                >
                                {{ partner.name | formatName }}
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                </div>
                <div class="row mb-3 pb-2">
                    <div class="col-6 mt-4">
                        <p class="c-nadarkfour bold mb-2">
                            Logo do sacado
                        </p>
                        <!-- <Upload v-model="fileListLogo" :multiple="false" @change="handleChange($event, true)"/> -->
                        <UploadGroup :img="group.logo" @change="handleLogoChange" @delete="handleLogoDelete"/>
                    </div>
                </div>
                <div class="row mb-4 pb-2" v-if="!USER_TYPE_MIXIN.isBackOffice">
                    <div class="col-6">
                        <p class="c-nadarkfour bold mb-2" >
                            Sobre o sacado
                        </p>
                        <!-- <Upload v-model="fileListAbout" :multiple="false" @change="handleChange($event, false)"/> -->
                        <UploadGroup :img="group.aboutPhoto" :about="true" @change="handleAboutChange" @delete="handleAboutDelete"/>
                    </div>
                </div>
            </el-form>
            <Button :color="getPrimaryColor" :disabled="!group.name.length" @click="nextStep">{{ this.$route.path.includes('update') ? 'Continuar' : 'Salvar' }}</Button>
        </div>
    </div>
</div>
</template>

<script>
import ArrowDropdown from '@/components/icons/ArrowDropdown'
import updateEconomicGroup from '@/api/updateEconomicGroup'
import insertEconomicGroupLogo from '@/api/insertEconomicGroupLogo'
import insertEconomicGroupAbout from '@/api/insertEconomicGroupAbout'
import deleteEconomicGroupLogo from '@/api/deleteEconomicGroupLogo'
import deleteEconomicGroupAbout from '@/api/deleteEconomicGroupAbout'
import UploadGroup from '@/components/uploads/UploadGroup'
import getEconomicGroup from '@/api/getEconomicGroup'
import getCompanyPartners from '@/api/getCompanyPartners'

export default {
    components: {
        ArrowDropdown,
        UploadGroup,
    },
    data() {
        return {
            activeStep: 0,
            group: {
                name: '',
                city: '',
                state: '',
                site: '',
                logo: '',
                aboutPhoto: '',
                partnerId: ''
            },
            logo: {
                id: '',
                fileName: '',
                logoFile: ''
            },
            aboutPhoto: {
                id: '',
                fileName: '',
                aboutFile: ''
            },
            partners: [],
        }
    },
    methods: {
        async nextStep() {
            const result = await updateEconomicGroup(this.$route.params.groupId, this.group)
            if (result.data.ok) {
                let resultLogo = true
                let resultAbout = true
                if (this.logo.logoFile.length) {
                    resultLogo = await insertEconomicGroupLogo(this.$route.params.groupId, this.logo)
                }
                if (this.aboutPhoto.aboutFile.length) {
                    resultAbout = await insertEconomicGroupAbout(this.$route.params.groupId, this.aboutPhoto)
                }
                if (resultLogo && resultAbout) {
                    this.$notify({
                        title: 'Alterações salvas com sucesso!',
                        message: '',
                        type: 'success',
                        duration: 3000,
                        offset: 100,
                        showClose: false,
                    });
                    if (this.$route.path.includes('update')) {
                        this.$router.push(`/group/${this.$route.params.groupId}/buyer`)
                    } else {
                        this.$router.push(`/group`)
                    }
                } else {
                    console.log('Erro')
                }
            } else {
                console.log('Erro')
            }           
        },
        handleLogoChange(base64File) {
            this.logo = {
                fileName: base64File.name,
                logoFile: base64File.file
            }
        },
        handleAboutChange(base64File) {
            this.aboutPhoto = {
                fileName: base64File.name,
                aboutFile: base64File.file
            }
        },
        async handleLogoDelete() {
            await deleteEconomicGroupLogo(this.$route.params.groupId)
        },
        async handleAboutDelete() {
            await deleteEconomicGroupAbout(this.$route.params.groupId)
        }
    },
    async created() {
        //const groupData = this.$store.state.group.groups.find(group => group.id == this.$route.params.groupId)
        const partners = await getCompanyPartners()
        this.partners = partners

        const result = await getEconomicGroup(this.$route.params.groupId)
        if (result.data.ok) {
            const { name, city, state, site, logo, aboutPhoto, partnerId } = result.data.payload
            this.group = {
                name,
                city,
                state,
                site,
                logo,
                aboutPhoto,
                partnerId
            }
        }
    },
    destroyed() {
        this.$store.commit('group/setGroup', {})
    }    
}
</script>

<style lang="scss" scoped>

</style>